import React, { useState, useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { capitalize } from '../../utils/text'
import moment from 'moment'


import FormService from '../../services/FormService'
import LocalStorageService from '../../services/LocalStorageService'
import { getRecordTerm } from '../../services/TermsService'
import UserService from '../../services/UserService'
import UserTagService from '../../services/UserTagService'

// Font Awesome

// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import Tabs from '../../components/simple/tabs/Tabs.js'
import Text from '../../components/simple/text/Text'

// ServiceUserEdit tabs
import Access from './tabs/Access'
import Logs from './tabs/Logs'
import Clickers from './tabs/Clickers'

// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'
import Overview from './tabs/Overview.js'
import Details from './tabs/Details.js'
import KeyContacts from './tabs/KeyContacts.js'
import Incidents from './tabs/Incidents.js'
import Plans from './tabs/Plans.js'
import ServiceUserProfileStats from './ServiceUserProfile-Stats.js'
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import { isServiceAdmin } from '../../utils/permissions.js'
// import Messenger from './tabs/Messenger.js'
import { ResponsiveContext } from 'grommet'

function ServiceProfile (props) {
  const navigate = useNavigate()

  const [userDetails, setUserDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    reference: '',
    dob: '',
    ethnicity: '',
    gender: ''
  })

  const [groupDetails, setGroupDetails] = useState({
    groupName: '',
    academicYear: ''
  })

  // Groups this User is a member of
  const [currentGroups, setCurrentGroups] = useState([])

  // All Groups for this Org
  const [allGroups, setAllGroups] = useState([])

  const [mappedContacts, setMappedContacts] = useState([])
  const [contactColumns, setContactDataColumns] = useState()

  const [contactDetails, setContactDetails] = useState({
    firstName: '',
    lastName: '',
    role: '',
    email: '',
    phone: ''
  })
  const [contacts, setContacts] = useState([])
  const [contactAddButton, setContactAddButton] = useState(false)
  const [allAcademicYears, setAllAcademicYears] = useState([])
  const [academicYearSelected, setAcademicYear] = useState()

  const [latestBehaviourPDF, setLatestBehaviourPDF] = useState('')

  const [showAllStats, setShowAllStats] = useState(false)

  // Disable tabs other than the first if creating new user
  // Enable after the first tab has been completed
  const [secondaryTabsDisabled, setSecondaryTabsDisabled] = useState(false)

  const [quickBehaviours, setQuickBehaviours] = useState([
    'Throwing',
    'Yelling',
    'Swearing',
    'Wandering'
  ])

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const activeUser = LocalStorageService.get('userDetails')
  const terms = LocalStorageService.get('terms')

  const addContact = () => {
    const contact = {
      firstName: contactDetails.firstName,
      lastName: contactDetails.lastName,
      role: contactDetails.role,
      email: contactDetails.email,
      phone: contactDetails.phone
    }
    setContacts(contacts => [...contacts, contact])

    // Re-initialise input fields
    setContactDetails({
      firstName: '',
      lastName: '',
      role: '',
      email: '',
      phone: ''
    })
    setContactAddButton(false)
  }



  const params = useParams()

  let userId = params.userid
  let tab = params.tab

  // Tab controls
  const [tabIndex, setTabIndex] = useState(0)
  const onActiveTab = (nextIndex) => {
    setTabIndex(nextIndex)
    navigate(`/serviceuser/${userId}/profile/${tabContent[nextIndex].name.toLowerCase().replace(' ', '')}`)
  }

  const tabContent = []
  tabContent.push({
    name: 'Overview',
    hideTitle: false,
    content: <Overview userDetails={userDetails} setUserDetails={setUserDetails} />,
    disabled: secondaryTabsDisabled
  })

   tabContent.push({
    name: 'Incidents',
    hideTitle: false,
    content: <Incidents userDetails={userDetails} setUserDetails={setUserDetails} />,
    disabled: secondaryTabsDisabled
  })

  tabContent.push({
    name: getRecordTerm(terms, 'smartPlanBuilderTerm', 'Plans'),
    hideTitle: false,
    content: <Plans userDetails={userDetails} setUserDetails={setUserDetails} />,
    disabled: secondaryTabsDisabled
  })

  tabContent.push({
    name: getRecordTerm(terms, 'communicationTerm', 'Communications'),
    hideTitle: false,
    content: <Logs userDetails={userDetails} setUserDetails={setUserDetails} />,
    disabled: secondaryTabsDisabled
  })

  // tabContent.push({
  //   name: 'Messenger',
  //   hideTitle: false,
  //   content: <Messenger userDetails={userDetails} setUserDetails={setUserDetails} />,
  //   disabled: secondaryTabsDisabled
  // })

  tabContent.push({
    name: 'Clickers',
    hideTitle: false,
    content: <Clickers userDetails={userDetails} setUserDetails={setUserDetails} />,
    disabled: secondaryTabsDisabled
  })

  tabContent.push({
    name: 'Details',
    hideTitle: false,
    content: <Details userDetails={userDetails} setUserDetails={setUserDetails} />,
    disabled: secondaryTabsDisabled
  })

  tabContent.push({
    name: 'Key Contacts',
    hideTitle: false,
    content: <KeyContacts userDetails={userDetails} setUserDetails={setUserDetails} />,
    disabled: secondaryTabsDisabled
  })

  if (isServiceAdmin()) {
    tabContent.push({
      name: 'Access',
      hideTitle: false,
      content: <Access userDetails={userDetails} setUserDetails={setUserDetails} />,
      disabled: secondaryTabsDisabled
    })
  }

  // tabContent.push({
  //   name: 'Logs',
  //   hideTitle: false,
  //   content: <Logs userDetails={userDetails} setUserDetails={setUserDetails} />,
  //   disabled: secondaryTabsDisabled
  // })

  //  tabContent.push({
  //   name: 'Clickers',
  //   hideTitle: false,
  //   content: <Clickers userDetails={userDetails} setUserDetails={setUserDetails} />,
  //   disabled: secondaryTabsDisabled
  // })


  // if (hasPermission('studentGrantDirectAccess')) {
  //   tabContent.push({
  //     name: 'Access',
  //     hideTitle: false,
  //     content: <Access userDetails={userDetails} setUserDetails={setUserDetails} />,
  //     disabled: secondaryTabsDisabled
  //   })
  // }

  useEffect(() => {

    if (!tab) { return }

    const tabNames = tabContent.map(item => item.name.toLowerCase().replace(' ', ''))
    const index = tabNames.indexOf(tab.toLowerCase())
    if (index !== -1) {
      setTabIndex(index)
    }

  }, [tab])


  const getContacts = async () => {
    const params = {
      fields: 'user,type,key,organisation,value'
    }

    const where = {
      user: userId
    }

    let contacts = await UserTagService.get(apiToken, params, where)

    // Filter out the 'keycontacts'
    if (contacts) {
      contacts = contacts.filter((item) => item.key === 'keycontacts')

      var parsedContacts
      try {
        parsedContacts = JSON.parse(contacts[0].value)
      } catch (err) {
        console.error(err)
      }

      if (parsedContacts) {
        setContacts(parsedContacts)
      }
    }
  }


  const goToRecord = (userId) => {
    navigate(`/record/${userId}`)
  }

   const goToSmartPlan = (userId) => {
    navigate(`/behaviour/${userId}/edit`)
  }

  // Basically componentDidMount
  useEffect(() => {
    let unmounted = false

    // Check if adding a new User or editing an existing one
    const getUserDetails = async (userId) => {
      let params = {
        fields: 'id,reference,firstName,dob,lastName,email,userName,ethnicity,gender,createdAt',
        limit: 1,
        orgId: activeOrg.id,
        type: 'student'
      }

      const userDetails = await UserService.getUser(apiToken, params, userId)

      if (!userDetails?.data?.length) { return }

      if (!unmounted) {
        setUserDetails(prevState => ({
          ...prevState,
          id: userDetails.data[0].id,
          reference: userDetails.data[0].reference,
          firstName: userDetails.data[0].firstName,
          lastName: userDetails.data[0].lastName,
          dob: moment(userDetails.data[0].dob).format('YYYY-MM-DD'),
          ethnicity: userDetails.data[0].ethnicity || '',
          gender: userDetails.data[0].gender
        }))

        // Now get the most recent Behaviour Plan PDF
        params = {
          fields: 'id,pdfUrl',
          limit: 1,
          orgId: activeOrg.id,
          sort: 'id DESC'
        }

        var where = {
          status: 'Published',
          type: 'behaviourplan',
          user: userDetails.data[0].id,
          author: activeUser.id
        }

        // don't filter by author if smart plans are shared
        if (activeOrg.sharedSmartPlans) {
          delete where.author
        }

        const submission = await FormService.getSubmissions(apiToken, params, where)

        if (submission?.data?.[0]?.pdfUrl) {
          setLatestBehaviourPDF(submission.data[0].pdfUrl)
        }
      }
    }
    if (userId !== 'new') {
      getUserDetails(userId)
      setSecondaryTabsDisabled(false)
    }

    // getAcademicYear()

    return () => { unmounted = true }
  }, [userId])


  return (
    <ResponsiveContext.Consumer>
      {(size) => {
        return (
          <Box width='xlarge' pad={{ bottom: 'xlarge' }} gap='small' alignSelf='center'>
            <BreadcrumbBar
              title={`${capitalize(terms?.serviceUser || 'Service User')}: ${userDetails.id ? userDetails.firstName + ' ' + userDetails.lastName : 'New User'}`}
              path={<><Anchor href='/'>BehaviourSmart</Anchor><Text color='besmartBlue' size='xsmall'>{window.location.pathname}</Text></>}
            />


            <Box direction='row' justify='end' gap='none' pad={{ vertical: 'none', bottom: 'none' }} margin='none'>
                <Box
                  direction='row'
                  align='center'
                  gap='small'
                  margin={{ right: 'small' }}
                  flex='grow'
                >
                  <Text color='white' size="large" weight='bold'>Actions:</Text>
                </Box>
                <ActionButton label='Record' labelIcon={['fal', 'plus-circle']} onClick={() => goToRecord(userDetails.id)} target='_self' />
              <ActionButton label={getRecordTerm(terms, 'smartPlanBuilderTerm', 'Smart Plan Builder')} labelIcon={['fal', 'clipboard-list-check']} onClick={() => goToSmartPlan(userDetails.id)} target='_self' />

                <ActionButton labelIcon={['fal', 'chart-pie']} onClick={() => setShowAllStats(!showAllStats)} label={showAllStats ? 'Hide Full Stats' : 'Show Full Stats'} alignSelf='center' />
            </Box>
            <Box direction='row' justify='end' gap='small' pad={{ vertical: 'none' }}>
              <ServiceUserProfileStats userId={userId} showAllStats={showAllStats} />
            </Box>

            {!showAllStats && <Box background='white' direction='column' gap='small' round='small' flex='grow'>
              <Box
                gap='small'
                margin={{ horizontal: 'small' }}
                pad='small'
                round='medium'
              >
                <Box direction='column' gap='medium'>
                  <Tabs activeIndex={tabIndex} content={tabContent} onActive={onActiveTab} />
                </Box>
              </Box>
            </Box>}
          </Box>
        )
      }}
    </ResponsiveContext.Consumer>
  )
}

export default ServiceProfile
